module.exports = __webpack_public_path__ + "img/news8-7.c36bdeef.png";